import { PageEmpty, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans } from 'react-i18next'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  empty: {
    marginVertical: Spacing.L,
  },
})

const ProductEmpty = () => {
  return (
    <PageEmpty>
      <Text level={2}>
        <Trans>There's nothing here yet</Trans>
      </Text>
      <Text style={styles.empty}>
        <Trans>Add your first remark and it will be listed here...</Trans>
      </Text>
    </PageEmpty>
  )
}

export default ProductEmpty
